import React, { useCallback } from 'react';
import { EntityTypeType } from '~/components/Admin';
import { ServicesContext } from '~/services';

export const useGetUserRoles = () => {
    const services = React.useContext(ServicesContext);

    const getUserRoles = useCallback(
        async (userId: number, entityType: EntityTypeType) => {
            const result = await services.api.call({
                method: 'get',
                url: `/api/${entityType}-users`,
                params: {
                    'user.id': userId,
                },
            });
            return result.data['hydra:member'];
        },
        [services.api]
    );

    return getUserRoles;
};
